import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs',
})
export class AbsPipe implements PipeTransform {
  public transform(value: number, maxParts = 1, suffix = 'ago', useShort = false): number {
    return Math.abs(value);
  }
}
